import React from "react";
import ExploreSection from "./ExploreSection";
import EngageSection from "./EngageSection";
import VerifySection from "./VerifySection";
import "../styles/JourneySection.css";
import InsightSection from "./InsightSection";

const JourneySection = () => {
  return (
    <div className="journey-section" id="journey-section">
      <p className="journey-text">
        Need help choosing? Follow our guided journey to become a confident
        voter
      </p>
      <ExploreSection />
      <EngageSection />
      <VerifySection />
      <InsightSection />
    </div>
  );
};

export default JourneySection;
